import { createApp } from 'vue/dist/vue.esm-bundler.js'
import { createPinia } from 'pinia'
import App from './App.vue'


// Third Party Globals
import Lenis from 'lenis'
import { plugin, defaultConfig } from '@formkit/vue'
import { de } from '@formkit/i18n'

// Directives
import { gtmHelper } from '@/directives/gtm-helper.js'
import { utmHelper } from '@/directives/utm-helper.js'

// Node Templates
import DataGrid from '@/components/Landingpage/DataGrid.vue';
import EventGroups from '@/components/Event/Groups.vue';
import EventHotelDescription from '@/components/Event/HotelDescription.vue';
import InhouseStepList from '@/components/InhouseSeminar/StepList.vue';
import MemberCircle from '@/components/Member/Circle.vue';
import MemberEvents from '@/components/Member/Events.vue';
import StudyStepList from '@/components/Study/StepList.vue';
import StudyStepListWrapper from '@/components/Study/StepListWrapper.vue';

// Paragraphs used as Drupal Page Builder Blocks
import ElementAccordion from '@/components/Paragraphs/Accordion.vue';
import ElementHero from '@/components/Paragraphs/Hero.vue';
import ElementMethodology from '@/components/Paragraphs/Methodology.vue';
import ElementRange from '@/components/Paragraphs/Range.vue';
import ElementTag from '@/components/Paragraphs/Tag.vue';
import ElementTargetGroups from '@/components/Paragraphs/TargetGroups.vue';
import ElementTeaserRow from '@/components/Paragraphs/TeaserRow.vue';
import ElementTimeline from '@/components/Paragraphs/Timeline.vue';
import ElementText from '@/components/Paragraphs/Text.vue';
import ElementVideo from '@/components/Paragraphs/Video.vue';

// UI Componenets for global use
import AppForm from '@/components/Form/AppForm.vue';
import AppMultistepForm from '@/components/Form/AppMultistepForm.vue';
import AppIcon from '@/components/Ui/AppIcon.vue';
import AppMenu from '@/components/Ui/AppMenu.vue';
import AppMenuToggle from '@/components/Ui/AppMenuToggle.vue';
import FadeList from '@/components/Ui/FadeList.vue';
import LeftHeadline from '@/components/Ui/LeftHeadline.vue';
import Media from '@/components/Ui/Media.vue';
import StudyCompletionIndicator from '@/components/Study/CompletionIndicator.vue';
import UserLoginForm from '@/components/Ui/UserLoginForm.vue';

// Utility Items
import AppCounter from '@/components/Utility/Counter.vue';
import ContactWidget from '@/components/Utility/ContactWidget.vue';
import ExportPdf from '@/components/Utility/ExportPdf.vue';
import GridLayout from '@/components/Utility/GridLayout.vue';
import QuoteSlider from '@/components/Utility/QuoteSlider.vue';
import SocialButton from '@/components/Utility/SocialButton.vue';
import SwiperBase from '@/components/Utility/SwiperBase.vue';

// Wishlist
import WishlistAddButton from '@/components/Wishlist/AddButton.vue';
import WishlistMenuButton from '@/components/Wishlist/MenuButton.vue';
import WishlistGrid from '@/components/Wishlist/Grid.vue';
import WishlistWarning from '@/components/Wishlist/Warning.vue';

// Initialize Lenis
const lenis = new Lenis();

// Use requestAnimationFrame to continuously update the scroll
function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}

requestAnimationFrame(raf);

const pinia = createPinia()
const app = createApp(App)

app.use(plugin, defaultConfig({
  locales: {
    de
  },
  locale: 'en'
}))

app.use(pinia)

// Directives
app.directive('gtm-helper', gtmHelper)
app.directive('utm-helper', utmHelper)

app
  // Node Templates
  .component('DataGrid', DataGrid)
  .component('EventGroups', EventGroups)
  .component('EventHotelDescription', EventHotelDescription)
  .component('InhouseStepList', InhouseStepList)
  .component('MemberCircle', MemberCircle)
  .component('MemberEvents', MemberEvents)
  .component('StudyStepList', StudyStepList)
  .component('StudyStepListWrapper', StudyStepListWrapper)

  // Paragraphs
  .component('ElementAccordion', ElementAccordion)
  .component('ElementHero', ElementHero)
  .component('ElementMethodology', ElementMethodology)
  .component('ElementRange', ElementRange)
  .component('ElementTag', ElementTag)
  .component('ElementTargetGroups', ElementTargetGroups)
  .component('ElementTeaserRow', ElementTeaserRow)
  .component('ElementText', ElementText)
  .component('ElementTimeline', ElementTimeline)
  .component('ElementVideo', ElementVideo)

  // UI
  .component('AppForm', AppForm)
  .component('AppMultistepForm', AppMultistepForm)
  .component('AppIcon', AppIcon)
  .component('AppMenu', AppMenu)
  .component('AppMenuToggle', AppMenuToggle)
  .component('FadeList', FadeList)
  .component('LeftHeadline', LeftHeadline)
  .component('Media', Media)
  .component('StudyCompletionIndicator', StudyCompletionIndicator)
  .component('UserLoginForm', UserLoginForm)

  // Utility
  .component('AppCounter', AppCounter)
  .component('ContactWidget', ContactWidget)
  .component('ExportPdf', ExportPdf)
  .component('GridLayout', GridLayout)
  .component('QuoteSlider', QuoteSlider)
  .component('SocialButton', SocialButton)
  .component('SwiperBase', SwiperBase)

  // Wishlist
  .component('WishlistAddButton', WishlistAddButton)
  .component('WishlistGrid', WishlistGrid)
  .component('WishlistMenuButton', WishlistMenuButton)
  .component('WishlistWarning', WishlistWarning)

app.mount('#app')
